import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { debounce } from 'throttle-debounce';
import { MediaQuery, Alert, CheckboxList } from '@grandvisionhq/common';
import { ConfiguratorStepTitleAndDescription, ConnectedStepForm } from '@grandvisionhq/configurator';
import { DateOfBirthSelect, Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../Context/RxGlassesConfiguratorContext.js';
import DesktopStepLayout from '../components/DesktopStepLayout/DesktopStepLayout.js';
import { RxStepWrapper } from '../components/RxStepWrapper/RxStepWrapper.js';

const PrescriptionStepValidationStep = ({ className , prescriptionInfoFormState , showValidationError , verificationAllowed , onVerificationAllowedChange , onChange , onSubmit ,  })=>{
    const { getLabel  } = useIntl();
    const placeholderLabels = {
        dayPlaceholder: getLabel('common.placeholder.day.abbr'),
        monthPlaceholder: getLabel('common.placeholder.month.abbr'),
        yearPlaceholder: getLabel('common.placeholder.year.abbr')
    };
    const isDesktop = MediaQuery.useIsDesktop();
    const verificationCheckbox = React__default.useMemo(()=>({
            label: getLabel('products.glasses.validationStep.verificationAllowed.checkbox'),
            value: 'verificationAllowed'
        })
    , [
        getLabel
    ]);
    const handleFormChange = React__default.useCallback(debounce(250, (state)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(state.formState);
    }), [
        onChange
    ]);
    const handleConsentChange = React__default.useCallback((selectedItems)=>{
        onVerificationAllowedChange === null || onVerificationAllowedChange === void 0 ? void 0 : onVerificationAllowedChange(!!selectedItems.includes(verificationCheckbox));
    }, [
        onVerificationAllowedChange
    ]);
    const { opticianForm  } = useRxGlassesConfiguratorContext();
    const currentYear = new Date().getFullYear();
    const isDesignV2 = true;
    const Wrapper = DesktopStepLayout ;
    return /*#__PURE__*/ React__default.createElement(RxStepWrapper, {
        className: classnames('prescription-validation-step', className),
        "data-t": "prescription-validation-step"
    }, /*#__PURE__*/ React__default.createElement(Wrapper, null, /*#__PURE__*/ React__default.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop && isDesignV2 ? 'left' : 'center'
    }), showValidationError && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        title: getLabel('products.glasses.validationStep.form.validationError'),
        className: "prescription-validation-step__alert"
    }), /*#__PURE__*/ React__default.createElement(ConnectedStepForm, {
        className: "prescription-validation-step__form",
        initialFormState: prescriptionInfoFormState,
        onChange: handleFormChange,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(DateOfBirthSelect, swcHelpers.extends({
        required: true,
        name: "expiryDate",
        label: getLabel('products.glasses.validationStep.expiryDate'),
        errorMessage: getLabel('products.glasses.validationStep.expiryDate.errorMessage'),
        validations: [
            Util.validations.isDate
        ],
        tooltipLabel: getLabel('products.glasses.validationStep.expiryDate.tooltip'),
        minYear: currentYear,
        maxYear: currentYear + 3
    }, placeholderLabels)), opticianForm && opticianForm(), /*#__PURE__*/ React__default.createElement(CheckboxList, {
        idPrefix: "prescription_validation__",
        items: [
            verificationCheckbox
        ],
        selectedItems: verificationAllowed ? [
            verificationCheckbox
        ] : [],
        onChange: handleConsentChange,
        getItemIdentifier: (item)=>item.value
        ,
        renderItem: (item)=>item.label
    }))));
};
var PrescriptionValidationStep = PrescriptionStepValidationStep;

export { PrescriptionValidationStep as default };
//# sourceMappingURL=PrescriptionValidationStep.js.map
